var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelayedDeliveriesKpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 40,
    viewBox: "0 0 28 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40839",
    d: "M3.23077 39.3846H24.7692V34.5239C24.7692 31.7828 23.644 29.1619 21.6567 27.2739L14.6888 20.6543C14.3028 20.2877 13.6972 20.2877 13.3113 20.6543L6.34327 27.2739C4.35597 29.1619 3.23077 31.7828 3.23077 34.5239V39.3846Z",
    fill: "#12D9E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250694",
    d: "M24.7689 8.69226H3.23047C3.23047 8.69226 4.35841 10.4766 6.46124 13C8.56406 15.5233 13.9997 19.4615 13.9997 19.4615C13.9997 19.4615 18.7823 16.3503 20.9997 13.5384C22.9222 11.1005 24.7689 8.69226 24.7689 8.69226Z",
    fill: "#12D9E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40837",
    d: "M3.23077 39.3846H24.7692M3.23077 39.3846V34.5239C3.23077 31.7828 4.35597 29.1619 6.34327 27.2739L13.3113 20.6543C13.6972 20.2877 14.3028 20.2877 14.6888 20.6543L21.6567 27.2739C23.644 29.1619 24.7692 31.7828 24.7692 34.5239V39.3846M3.23077 39.3846H0M24.7692 39.3846H28",
    stroke: "#383434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40838",
    d: "M3.23077 0.615356H24.7692M3.23077 0.615356V5.47609C3.23077 8.2172 4.35597 10.8381 6.34327 12.7261L13.3113 19.3457C13.6972 19.7123 14.3028 19.7123 14.6888 19.3457L21.6567 12.7261C23.644 10.8381 24.7692 8.2172 24.7692 5.47608V0.615356M3.23077 0.615356H0M24.7692 0.615356H28",
    stroke: "#383434"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelayedDeliveriesKpi);
export default __webpack_public_path__ + "static/media/Delayed_DeliveriesKPI.c91f65efcf499d9b5a97877e80cc0c71.svg";
export { ForwardRef as ReactComponent };